import { render, staticRenderFns } from "./SaleBuyer.vue?vue&type=template&id=ee1db3ec&scoped=true"
import script from "./SaleBuyer.vue?vue&type=script&lang=js"
export * from "./SaleBuyer.vue?vue&type=script&lang=js"
import style0 from "./SaleBuyer.vue?vue&type=style&index=0&id=ee1db3ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1db3ec",
  null
  
)

export default component.exports